import { intelClient } from 'src/api/config';

function fetchTicket() {
  return intelClient.post('/api/auth/bi');
}

export default fetchTicket;
